import { useEffect, useState } from "react"
import { createPortal } from "react-dom";
import { Button, Modal } from "@prosolve/common-components-ui"
import ActionButton from "../Shared/ActionButton";
import styled from "styled-components";
import { FaLink } from "react-icons/fa";

const Body = styled.div`
  height: 100%;
  align-content: center;

  font-size: 36px;
  color: rgb(86, 86, 86);
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
`

const Link = styled.a`
  color: rgb(51, 175, 231);
  text-decoration: none;
`


export function OpportunityShare ({ 
  opportunity,
  onLinkCopy
}) {
  const link = `${window.location.origin}/ship/opportunity/${opportunity?.Id}`
  const [isLinkCopied, setIsLinkCopied] = useState(false)

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    setIsLinkCopied(true)
    onLinkCopy?.()
  }

  return (
    <Body>
      <Column>
        <div>To share a link to this opportunity, go to:</div>
        <div><Link href={link} target="_blank" rel="noreferrer">{link}</Link></div>
        <div>
          <ActionButton onClick={copyLink} $disabled={isLinkCopied} style={{ fontWeight: 'bold', padding: '20px 30px', borderRadius: '30px' }}>
            <FaLink style={{ marginRight: '10px' }} />
            {!isLinkCopied ? 'Copy Link' : 'Link copied to clipboard'}
          </ActionButton>
        </div>
      </Column>
    </Body>
  )
}

export function OpportunityShareModal ({
  onClose: onCloseParam, 
  opportunity
}) {

  const onOpen = () => {
    document.documentElement.style.overflow = 'hidden'
  }

  const onClose = () => {
    onCloseParam?.(false)
    document.documentElement.style.overflow = 'auto'
  }

  const onLinkCopy = () => {
    setTimeout(onClose, 1000);
  }

  useEffect(() => {
    onOpen()
  }, [])
  
  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      fontSize: '16px',
      fontWeight: 'normal',
      padding: '10px'
    }}>
      <Button onClick={onClose} $colored={true}>
        {'Close'}
      </Button>
    </div>
  )

  const modal = (
    <Modal title={'Share Opportunity'} onClose={onClose} footer={footer} isFullScreen={true}>
      <OpportunityShare opportunity={opportunity} onLinkCopy={onLinkCopy} />
    </Modal>
  )

  return (<>
    {createPortal(modal, document.body)}
  </>)
}

export default function ManageOpportunityButton ({
  opportunity
}) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionButton onClick={() => setIsOpen(true)}>Share Opportunity</ActionButton>
      {isOpen &&
        <OpportunityShareModal opportunity={opportunity} onClose={() => setIsOpen(false)} />
      }
    </>
  )
}